import { isContainerBlock, TBlock, TTemplate } from '@wp-block-builder/package';

type TConfiguration = TTemplate & {
  subjectTemplate: string | null;
  strictVariablesRendering: boolean;
};

function expandBlocks(layoutBlocks: TBlock[], bodyBlocks: TBlock[]): TBlock[] {
  return expandDescendantBlocks(layoutBlocks, bodyBlocks) as TBlock[];
}

type TNullableBlock = TBlock | null;
function expandDescendantBlocks(layoutBlocks: TNullableBlock[], bodyBlocks: TNullableBlock[]): TNullableBlock[] {
  const index = layoutBlocks.findIndex((b) => b?.type === 'ContainerYield');
  if (index >= 0) {
    return [...layoutBlocks.slice(0, index), ...bodyBlocks, ...layoutBlocks.slice(index + 1)];
  }

  return layoutBlocks.map((bl) => {
    if (bl === null) {
      return null;
    }
    if (!isContainerBlock(bl)) {
      return bl;
    }
    return {
      ...bl,
      props: {
        ...bl.props,
        blocks: expandDescendantBlocks(bl.props?.blocks ?? [], bodyBlocks),
      },
    } as TBlock;
  });
}

export default function buildDocumentConfiguration(
  bodyConfiguration: TConfiguration,
  layoutConfiguration: TConfiguration | null | undefined
): TConfiguration {
  if (!layoutConfiguration) {
    return bodyConfiguration;
  }

  return {
    ...bodyConfiguration,
    strictVariablesRendering: bodyConfiguration.strictVariablesRendering,
    preheaderTemplate: bodyConfiguration.preheaderTemplate,
    subjectTemplate: bodyConfiguration.subjectTemplate,
    backdropStyle: layoutConfiguration.backdropStyle,
    canvasStyle: layoutConfiguration.canvasStyle,
    linkStyle: layoutConfiguration.linkStyle,
    blocks: expandBlocks(layoutConfiguration.blocks, bodyConfiguration.blocks),
  };
}
